import { useState } from 'react'
import { useSiteData } from '../../../../context/fetchContext'
import Document from './Document'
import Breadcrumbs from './Breadcrumbs'
import ControlPanel from './ControlPanel'

const Manage = ({ token, setLoading, fullGalleryData, setFullGalleryData }: any) => {
  const [selectedFolderIndex, setSelectedFolderIndex] = useState<number | undefined>()

  const openedFolder = fullGalleryData[selectedFolderIndex ?? -1]

  const [selectedItems, setSelectedItems] = useState([])
  return (
    <div className='flex flex-col gap-4 w-[653px]'>
      <Breadcrumbs utils={{ openedFolder, setSelectedFolderIndex }} />
      <ControlPanel
        token={token}
        utils={{
          openedFolder,
          setFullGalleryData,
          selectedItems,
          setSelectedItems,
          setLoading
        }}
      />
      {/* NOTE - Add a fade in animation and a fate out animation like it is in pcloud */}
      <div className='overflow-auto h-[300px]'>
        {openedFolder ? (
          <div className='grid grid-cols-5 gap-3'>
            {openedFolder.files.map((file: any, i: number) => (
              <Document
                document={file}
                key={i}
                utils={{
                  openFolder: () => setSelectedFolderIndex(i),
                  parentFolder: openedFolder,
                  setSelectedItems,
                  selectedItems,
                  fullGalleryData
                }}
              />
            )
            )}
          </div>
        ) : (
          <div className='grid grid-cols-3 gap-3'>
            {fullGalleryData.map((folder: any, i: number) => (
              <Document
                document={folder}
                isFolder
                key={i}
                utils={{
                  openFolder: () => setSelectedFolderIndex(i),
                  setSelectedItems,
                  selectedItems,
                  fullGalleryData
                }}
              />
            )
            )}
          </div>
        )}

      </div>
    </div>
  )
}



export default Manage